import React, { useState, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
// Redux
import { useDispatch } from "react-redux";
import { clinicianVerifyToken } from "../redux/clinicianDucks";
// Constants
import { pathHomePage } from "./constants";

const VerifyToken = () => {
  const [redirect, setRedirect] = useState(false);
  const { clinicianToken } = useParams();
  const dispatch = useDispatch();

  const validateClinician = () => {
    if (clinicianToken !== "") {
      try {
        const clinicianData = jwt_decode(clinicianToken);
        if (clinicianData.data.CLINICIAN_ID) {
          clinicianData.data.token = clinicianToken;
          const data = clinicianData.data;
          dispatch(clinicianVerifyToken({ data }));
        } else {
          setRedirect(true);
        }
      } catch (error) {
        console.log("invalid jwt: ", error);
        setRedirect(true);
      }
    } else {
      setRedirect(true);
    }
  };

  useEffect(() => {
    validateClinician();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (redirect) {
    return <Redirect to={pathHomePage} />;
  }
};

export default VerifyToken;
